
import { Options, Vue } from "vue-class-component";

@Options({})
export default class RgbaToHex extends Vue {
  colorHex = "45ca58";
  colorCalculated = "";
  errorMessage = "";

  mounted() {
    this.changeColorCalculatedString();
  }
  changeColorCalculatedString() {
    let hex = this.colorHex.toUpperCase().replace(/\W/g, "");
    const hexLength = hex.length;

    if (hexLength > 0 && hexLength <= 6) {
      const h = "0123456789ABCDEF";
      if (hexLength == 6) {
      } else if (hexLength == 3) {
        hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
      } else {
        var loopLength = 6 - hexLength;

        var zeros = "";
        var i;
        for (i = 0; i < loopLength; i++) {
          zeros += "0";
        }
        hex = zeros + hex;
      }
      const r = h.indexOf(hex[0]) * 16 + h.indexOf(hex[1]);
      const g = h.indexOf(hex[2]) * 16 + h.indexOf(hex[3]);
      const b = h.indexOf(hex[4]) * 16 + h.indexOf(hex[5]);
      this.colorHex = hex
      this.$emit("colorRgba", {
        color: 'rgba(' + r +',' + g + ',' + b + ',1)',
        hex: hex
      });
      this.errorMessage = ""
    } else {
      this.errorMessage = "Fehlerhafte Eingabe"
    }
  }
}
